const TODO_ACTIONS = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    UPDATE: 'UPDATE',
    CHECK: 'CHECK',

    TODO_ITEM_ACTION_REQUEST: 'TODO_ITEM_ACTION_REQUEST',
    TODO_ITEM_ACTION_FAILURE: 'TODO_ITEM_ACTION_FAILURE',
    TODO_ITEM_ACTION_SUCCESS: 'TODO_ITEM_ACTION_FAILURE',
};

export default TODO_ACTIONS;
